import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Card,
  CardHeader,
  Table,
  Button
} from "reactstrap";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";
import config from "../../config";
import {generateHeaders, generateHeaderswithBasicAuthToken, generateEpochTimestamp, generateSignature} from "../../utils/helper";
export default class  MerchantOrderDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation:null,
      startDate:moment().endOf("day"),
      endDate:moment().endOf("day"),
      grandTotal:0.0,
      dropdownOpen: false,
      selectedStore: null,
      stores: [],
      merchantNames: [],
      storeIds: [],
      merchantName: '',
      selectedName: '',
      selectedStoreID:'',
      loading:false,
      loadingValue:'Please select'
    };
  }

  componentWillMount(){
    let reloadActive = localStorage.getItem("reloadActive");
    if (reloadActive === null) {
      localStorage.setItem("reloadActive", "Y");

      window.location.reload();
    }
    this.checkLoginMode();
  }
  componentDidMount() {
  }

  checkLoginMode = () => {
   
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if(loginMode === 'merchant'){
      this.setState({storeInformation:storeInformation});
      // this.getOrders();
    }else if("concessionaire"){
      this.setState({storeInformation:storeInformation,storeIds: storeInformation.concessionaire});
      this.getMerchantDetails();
    }

  };

  handleChange = event => {
    this.setState({ orders: [] ,grandTotal:0.0});

    for (let i = 0; i < this.state.merchantNames.length; i++) {
      if (this.state.merchantNames[i].node.name === event.target.value) {
        
        this.getStores(this.state.merchantNames[i].node.id,this.state.merchantNames[i].node.name);

        break;
      }
    }
  };
  getStores = async (merchantId,merchantName) => {
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getStores",
      {
        merchantId: merchantId
      }
    );

    if (response.error === null) {
      

      if (response.data.merchant.stores.edges.length > 0) {
        console.log("SelectedStoreID",response.data.merchant.stores.edges[0].node.id);
        this.setState({ stores: response.data.merchant.stores.edges,selectedStoreID:response.data.merchant.stores.edges[0].node.id,merchantName:merchantName });
        // this.getOrders();
        this.get_order_details();
      }
    }
  };
  getMerchantDetails = async () => {
    let requestManager = new RequestManager();

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getMerchantName"
    );

    if (response.error === null) {
      this.state.merchantNames.push({
        node: { name: "Select Merchant", id: "123" }
      });
      for (let i = 0; i < response.data.merchants.edges.length; i++) {
        this.state.merchantNames.push(response.data.merchants.edges[i]);
      }

      this.setState({ merchantNames: this.state.merchantNames });
    }
  };
  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };
  handleStartDateChange =(date)=> {
    this.setState({
      startDate: date
    });
  }
  handleEndDateChange =(date)=> {
    if ((Date.parse(this.state.startDate.format("MM/DD/YYYY")) >= Date.parse(date.format("MM/DD/YYYY")))) {
      if((Date.parse(this.state.startDate.format("MM/DD/YYYY")) === Date.parse(date.format("MM/DD/YYYY"))))
      {
        this.setState({
          endDate: date
        });
        
        console.log("endDate 1"+date.format("MM/DD/YYYY"))
      }else{
        alert("End date should be greater than Start date");
      }
    }else{
      console.log("endDate 2"+date)
      this.setState({
        endDate: date
      });
    }
  }
  get_order_details = async () => {
    console.log('inside get_order_details')
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let authToken = storeInformation.token;
    console.log('inside get_order_details')
    // region_name
    try {
      console.log('inside get_order_details-1')
      var vtimestamp = generateEpochTimestamp();
      let date='';
      let startdate = '';
      let enddate = '';
      if (this.state.startDate !== null) {
        date = this.state.startDate.format("YYYY-MM-DDT");
        date = date+"00:00:00+05:30";
        startdate = date;
      }
       
      if (this.state.endDate !== null) {
        date = this.state.endDate.format("YYYY-MM-DDT");
        date = date+"23:59:00+05:30";
        enddate = date;
      }
      let response = await fetch(
        config.getHost() + "/order/getstoreorderdetails/",
        {
          method: "POST",
          headers: {
            Authorization: `Token ${authToken}`,
            "Content-Type": "application/json",
            Timestamp: vtimestamp,
            Signature: generateSignature(vtimestamp, authToken)               
          },
          body: JSON.stringify({
            store_id: storeInformation.store.id,
            graphql:true,
            startdate:startdate,
            enddate:enddate
          }),
        }
      );
      console.log('URL', config.getHost() + "/order/getstoreorderdetails/");  
      console.log('get_order_details body',JSON.stringify({store_id: storeInformation.store.id, graphql:true, startdate:startdate, enddate:enddate
      }));

      if (response.status === 200) {
        let json = await response.json();
        let res = json.result;
        console.log("res", res);
        this.setState({ orders: res,loading:true });
        
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  getOrders = async () => {
    this.setState({orders:[],grandTotal:0.0,loadingValue: 'Please Wait a moment, loading',loading:false})
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    let storeName;
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
      storeName = storeInformation.merchant.name;
    }else if (loginMode === "concessionaire"){
      params = {
        storeId: this.state.selectedStoreID
      };
      storeName = this.state.merchantName;
    }
    let date='';
    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DDT");
      date = date+"00:00:00+05:30";
      params.createdAt_Gte = date;
    }
     
    if (this.state.endDate !== null) {
      params.createdAt_Lte = this.state.endDate.format();
    }
    console.log("params",params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getMerchantOrderDetails",
      params
    );

    if (response.error === null) {

     
      let orders=[],params;
      console.log("getMerchantOrderDetails",response.data);
      let grandTotal=0.0;
       for(let i=0; i < response.data.orderHistory.edges.length;i++){
        let token = response.data.orderHistory.edges[i].node.storeToken;
        let orderId = response.data.orderHistory.edges[i].node.orderId;
        let status = response.data.orderHistory.edges[i].node.status;
       
        
        console.log("token" +token)
        let createdAt = moment(response.data.orderHistory.edges[i].node.createdAt).format(
          "MMMM DD YYYY, h:mm a"
        );
        console.log("orderId"+orderId)
        console.log("createdAt"+createdAt)
        for(let j=0; j<response.data.orderHistory.edges[i].node.cart.cartItems.edges.length; j++){
         
          let referenceName = response.data.orderHistory.edges[i].node.cart.cartItems.edges[j].node.stock.referenceName;
          let settlementPrice = response.data.orderHistory.edges[i].node.cart.cartItems.edges[j].node.settlementPrice;
          let quantity = response.data.orderHistory.edges[i].node.cart.cartItems.edges[j].node.quantity;
          // if(quantity !== null)
          //   grandTotal = grandTotal+(settlementPrice*quantity) 
          // else
            grandTotal = grandTotal+settlementPrice 

          params = {storeToken:token,orderId:orderId,createdAt:createdAt,referenceName:referenceName,settlementPrice:settlementPrice,quantity:quantity,status:status,storeName:storeName}
          orders.push(params);
          for(let k=0; k<response.data.orderHistory.edges[i].node.cart.cartItems.edges[j].node.customizations.edges.length; k++){
           let parentName= response.data.orderHistory.edges[i].node.cart.cartItems.edges[j].node.customizations.edges[k].node.parent.name;
           console.log("referenceName"+parentName)
           let childName= response.data.orderHistory.edges[i].node.cart.cartItems.edges[j].node.customizations.edges[k].node.name;
           let settlementPrice= response.data.orderHistory.edges[i].node.cart.cartItems.edges[j].node.customizations.edges[k].node.settlementPrice;
           if(settlementPrice !==0){
              grandTotal = grandTotal+settlementPrice
           } 
           params = {storeToken:token,orderId:orderId,createdAt:createdAt,referenceName:parentName+": "+ childName,settlementPrice:settlementPrice,quantity:quantity,status:status,storeName:storeName};
           orders.push(params);
          }
        }
       }
       console.log(response.data.orderHistory.edges)
      if(response.data.orderHistory.edges.length === 0)
       this.setState({ orders: orders, loadingValue:'No Rows Found',loading:false});
      else
       this.setState({ orders: orders,grandTotal:grandTotal.toFixed(2),loading:true});
      
    }

  };

  // getCountOfItems = () => {
  //   if (this.state.selectedOrder) {
  //     let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
  //     let quantity = 0;
  //     cartItems.forEach(cartItem => {
  //       quantity = quantity + cartItem.node.quantity;
  //     });

  //     return quantity;
  //   }
  // };

  getCSVData = () => {
    
    let date='';
    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DD");
      // date = date+"00:00:00+00:00";
    }
    
    let csvData = [
      [
        "Your Order Details",
      ],
      [
        // "Grand Total",
        "Start Date",
        "End Date",
        
      ],
      [
        // this.state.grandTotal,
        date,
        this.state.endDate.format("YYYY-MM-DD")
      ],
      [
        "",
      ],
      [
        "",
      ],
   
      [
        "Store Name",
        "Order Id",
        "Status",
        "Date/Time",
        "Item",
        "Sku Code",
        "Unit Price",
        "Quantity",
        "Subtotal",
        "Discount",
        "Pre Tax Total",
        "Tax",
        "Total"
      ]
    ];
    // eslint-disable-next-line
    this.state.orders && this.state.orders.map(order => {
      csvData.push([
        order.storeName,
        order.orderId,
        order.status,
        order.date,
        order.productName,
        order.skuCode,
        order.unitPrice,
        order.quantity,
        order.subTotal,
        order.discount,
        order.preTaxTotal,
        order.tax,
        order.total
      ]);
    });
    return csvData;
  };

  render() {
    let loginMode = localStorage.getItem("loginMode");
    return (
      <Container fluid style={{ padding: 0, margin: 0 }}>
      
        <Row noGutters>
          <Col xs="12">
            <Card>
              <CardHeader>
                <Container fluid>
                  <Row>
                    <Col
                      xs="12"
                      sm="12"
                      md="4"
                      lg="4"
                      style={{ display: "flex", alignItems: "center" }}
                    >
                      <h5>Your Order Details</h5>
                    </Col>
                  </Row>
                  <Row> 
                  { loginMode === 'concessionaire' ?
                  <div style={{ padding: 10 }}>
                  <select onChange={this.handleChange}>
                    {this.state.merchantNames.map(names => (
                      <option>{names.node.name}</option>
                    ))}
                  </select>
                  </div> : null
                }
                </Row>
                  <Row>
                    
                    <Col
                    xs="12"
                    sm="12"
                    md="4"
                    lg="4"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                  </Col>
                    <Col xs="12" sm="12" md="8" lg="8">
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-end"
                        }}
                      >
                      <DatePicker
                      selected={this.state.startDate}
                      maxDate={moment().endOf("day")}
                      dateFormat="DD/MM/YYYY"
                     
                      onChange={this.handleStartDateChange}
                      />
                      <div style = {{marginLeft:15}}>
                        <DatePicker
                          selected={this.state.endDate}
                          dateFormat="DD/MM/YYYY"
                          maxDate={moment().endOf("day")}
                          onChange={this.handleEndDateChange}
                        />
                      </div>
                      {/* <h5 style={{marginLeft:20}}>{ 'Grand Total= ' +this.state.grandTotal}</h5> */}
                      {/* <Button style={{marginLeft:20,backgroundColor:'#00a9db',color:'white'}} onClick = { this.getOrders}>Submit</Button> */}
                      <Button style={{marginLeft:20,backgroundColor:'#00a9db',color:'white'}} onClick = { this.get_order_details}>Submit</Button>
                      {
                        // <DateRangePicker
                        //   startDate={this.state.startDate}
                        //   startDateId={"unique_start_date_id"}
                        //   endDate={this.state.endDate}
                        //   endDateId={"unique_start_date_id"}
                        //   focusedInput={this.state.focusedDate}
                        //   displayFormat="DD[/]MM[/]YYYY"
                        //   small={true}
                        //   isOutsideRange={day => {
                        //     return moment().endOf("day") <= day;
                        //   }}
                        //   onDatesChange={({ startDate, endDate }) => {
                        //     if (endDate != null) {
                        //       this.setState(
                        //         {
                        //           startDate: startDate.startOf("day"),
                        //           endDate: endDate.endOf("day"),
                        //           orders: []
                        //         },
                        //         () => {
                        //           this.getOrders();
                        //         }
                        //       );
                        //     }
                        //   }}
                        //   onFocusChange={focusedDate =>
                        //     this.setState({ focusedDate: focusedDate })
                        //   }
                        //   orientation="vertical"
                        // />
                        /* <Button disabled={this.state.orders.length <= 0} color='primary' onClick={this.exportDataToCSV} style={{marginLeft:10}}>Export to CSV</Button> */}
                        <CSVLink
                          className="btn btn-primary"
                          style={{ marginLeft: 20 }}
                          filename={"OrdersDetails.csv"}
                          data={this.getCSVData()}
                        >
                          Export to CSV
                        </CSVLink>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </CardHeader>
              <Table responsive>
                <tbody>
                  <tr>
                      <th>Store Name</th>
                      <th>Order Id</th>
                      <th>Status</th>
                      <th>Date/Time</th>
                      <th>Item</th>
                      <th>Sku Code</th>
                      <th>Unit Price</th>
                      <th>Quantity</th>
                      <th>Subtotal</th>
                      <th>Discount</th>
                      <th>Pre Tax Total</th>
                      <th>Tax</th>
                      <th>Total</th>
                   </tr>
                  {
                    this.state.loading === false ?
                    <tr>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td style={{textAlign:'center'}}>{this.state.loadingValue}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  :
                    this.state.orders.map(order => (
                    <tr>
                      
                       <td>{order.storeName}</td>
                      <td> {order.orderId}</td>
                      <td> {order.status}</td>
                      <td> {order.date}</td>
                      <td> {order.productName}</td>
                      <td> {order.skuCode}</td>
                      <td> {order.unitPrice}</td>
                      <td>  {order.quantity}</td>
                      <td> {order.subTotal}</td>
                      <td> {order.discount}</td>
                      <td> {order.preTaxTotal}</td>
                      <td> {order.tax}</td>
                      <td> {order.total}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </Col>
        </Row>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/MerchantOrderDetails/MerchantOrderDetails.js